/*

Scroll Service
==============

Monitor the scroll position of the site


*/

import Emitter from './Emitter'
import { USER_SCROLL } from '../events'

class Scroll {
	init(el) {
		this.state = {
			position: document.body.scrollTop,
			direction: 'DOWN',
			scrollBarWidth: this.measureScrollBarWidth()
		}

		this.bindScroll()
	}

	position() {
		return this.state.position
	}

	direction() {
		return this.state.direction
	}

	bindScroll() {
		window.addEventListener(
			'scroll',
			() => {
				this.onScroll()
			},
			{ passive: true }
		)
	}

	onScroll() {
		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout)
		}

		this.scrollTimeout = setTimeout(() => {
			let newPosition =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop ||
				0

			if (newPosition === this.state.position) return
			this.state.direction = newPosition > this.state.position ? 'DOWN' : 'UP'
			this.state.position = newPosition
			Emitter.emit(USER_SCROLL, this.state.position)
		}, 10)
	}

	measureScrollBarWidth() {
		var outer = document.createElement('div')
		outer.style.visibility = 'hidden'
		outer.style.width = '100px'
		outer.style.msOverflowStyle = 'scrollbar' // needed for WinJS apps

		document.body.appendChild(outer)

		var widthNoScroll = outer.offsetWidth
		// force scrollbars
		outer.style.overflow = 'scroll'

		// add innerdiv
		var inner = document.createElement('div')
		inner.style.width = '100%'
		outer.appendChild(inner)

		var widthWithScroll = inner.offsetWidth

		// remove divs
		outer.parentNode.removeChild(outer)

		return widthNoScroll - widthWithScroll
	}

	scrollBarWidth() {
		return this.state.scrollBarWidth
	}
}

let s = new Scroll()

window.addEventListener('DOMContentLoaded', () => {
	s.init()
})

export default s
